import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { ApiError, legacyAppUrl } from '@/lib/api'
import {
  Alert,
  Avatar,
  Empty,
  Kpi,
  KpiGrid,
  Muted,
  PageHeader,
} from '@/components/ui'
import { fetchAniversariantes } from './api'
import { formatDate } from './utils'

export function AniversariantesPage() {
  const [periodo, setPeriodo] = useState('mes')

  const lista = useQuery({
    queryKey: ['rh', 'aniversariantes', periodo],
    queryFn: () => fetchAniversariantes(periodo),
  })

  const dados = lista.data?.dados || []

  return (
    <section className="hi-page">
      <PageHeader
        title="Aniversariantes"
        subtitle="Nascimentos do período via API. Marcos de tempo de casa e automações no legado."
        actions={
          <a className="btn btn-secondary" href={legacyAppUrl('#/aniversariantes')}>
            Legado
          </a>
        }
      />

      <KpiGrid>
        <Kpi label="No período" value={String(lista.data?.total ?? dados.length)} />
      </KpiGrid>

      <form
        className="hi-filters"
        onSubmit={(e) => {
          e.preventDefault()
        }}
      >
        <select value={periodo} onChange={(e) => setPeriodo(e.target.value)}>
          <option value="hoje">Hoje</option>
          <option value="semana">Próximos 7 dias</option>
          <option value="mes">Este mês</option>
          <option value="todos">Todos (ativos com data)</option>
        </select>
      </form>

      {lista.isLoading ? <Muted>Carregando…</Muted> : null}
      {lista.isError ? (
        <Alert tone="danger">
          {lista.error instanceof ApiError ? lista.error.message : 'Falha ao listar.'}
        </Alert>
      ) : null}

      <ul className="hi-list">
        {dados.map((c) => (
          <li key={c.id}>
            <Link className="card card-interactive hi-row" to={`/app/rh/${c.id}`}>
              <Avatar src={c.foto_url || c.foto} nome={c.nome} iniciais={c.iniciais} />
              <div className="hi-row-main">
                <strong>{c.nome}</strong>
                <span>
                  {formatDate(c.data_nascimento)}
                  {c.cargo_nome ? ` · ${c.cargo_nome}` : ''}
                  {c.departamento_nome ? ` · ${c.departamento_nome}` : ''}
                </span>
              </div>
            </Link>
          </li>
        ))}
      </ul>

      {!lista.isLoading && dados.length === 0 ? (
        <Empty>Nenhum aniversariante neste filtro.</Empty>
      ) : null}
    </section>
  )
}

export default AniversariantesPage
